import { IOrganization } from '@shared/models';

export interface State {
  loading: boolean;
  data: IOrganization[];
  error: string;
}

export const initialState: State = {
  loading: false,
  data: [],
  error: null
};
